/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpRespShippingReturns_user = {| |};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespShippingReturns_user",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailShipping_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDetailPayments_user",
      "args": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
